export let getParentToggleStore = (parent) => {
    let toggleComponent = parent
    while (toggleComponent !== undefined && toggleComponent.purpose !== 'for-toggle-node') {
        toggleComponent = toggleComponent.$parent
    }

    if (!toggleComponent) {
        console.error('<toggle-trigger> or <toggle-content> should have <toggle> parent')
        return
    }
    return toggleComponent
}
